import asModal from '../../components/as-modal';

import { OrderSearchResult } from './index';

export const OrderSearchResultModal = asModal(OrderSearchResult);
